<template>
  <!-- 盘点单弹窗 -->
  <div>
    <BaseDialog title="选择入库单" @handleShow="(val) => {rkInfoDialog = val }" :isshow="rkInfoDialog" width="800px"
      height="auto">
      <div class="addform" style="margin-top:10px;">
        <div class="display_flex">
          <el-form :inline="true" :model="formData">
            <el-form-item label="入库单号">
              <el-input v-model="formData.orderNo" clearable />
            </el-form-item>
            <el-form-item label="供货单位">
              <el-select v-model="formData.supplier" placeholder="请选择">
                <el-option v-for="item in supplierList" :key="item" :label="item"
                  :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div style="margin-bottom: 18px;">
            <el-button class="color-main" type="primary" @click="search()">
              <i class="fa fa-search"></i>查询
            </el-button>
            <el-button class="color-main" @click="resetForm" type="primary">
              <i class="fa fa-refresh"></i>重置
            </el-button>
          </div>
        </div>
        <div class="main">
          <el-table v-loading="loading" :data="tableData" style="width: 100%" max-height="26vh" border>
            <el-table-column property="enter_time" width="180" label="入库时间" />
            <el-table-column width="130" prop="order_no" fixed label="入库单号" />
            <el-table-column prop="supplier" label="供货单位" show-overflow-tooltip />
            <el-table-column label="操作" align="center" width="100">
              <template #default="scope">
                <el-link @click="handle(scope.row)" type="primary">
                  选择
                </el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <template #footer>
        <div style="text-align: right" class="dialog-footer">
          <el-button @click="cancel">返回</el-button>
        </div>
      </template>
    </BaseDialog>
  </div>
</template>

<script setup>
  import {
    reactive,
    ref,
    onMounted,
    defineExpose,
    defineEmits,
    nextTick,
  } from 'vue'
  import service from '@/utils/request'
  import BaseDialog from '@/components/Dialog/index.vue'
  import { ElMessage } from 'element-plus'
  import { gitDictList, TimeYear, downLoadXlsx, TimestampToTime } from '@/utils/tool'
  const formData = ref({
    orderNo: '',
    supplier: ''
  })
  const rkInfoDialog = ref(false)
  const dictCatalogType = ref('')
  const tableData = ref([])
  const supplierList = ref([])
  const initData = (id) => {
    rkInfoDialog.value = true
    dictCatalogType.value = id
    for (const key in formData.value) {
      formData.value[key] = ''
    }
    tableData.value = []
    getSuire()
  }
  const resetForm = () => {
    for (const key in formData.value) {
      formData.value[key] = ''
    }
    search()
  }
  const getSuire = async ()=>{
    let res = await service.post('/api/store_enter_record/allsupplier')
    if (res.code === 0) {
      supplierList.value = res.data
    }
    
  }
  const search = async () => {
    let data = {
      ...formData.value,
      dict_catalog_type: dictCatalogType.value
    }
    let res = await service.post('/api/backoff/checkPassEnterOrderList', data)
    if (res.code === 0) {
      tableData.value = res.data.records
    }
  }
  //取消
  const cancel = async () => {
    rkInfoDialog.value = false
    for (const key in formData.value) {
      formData.value[key] = ''
    }
  }
  const em = defineEmits(['refreshDataList'])
  const handle = async (e) => {
    let data = {
      order_no: e.order_no
    }
    let res = await service.post('/api/backoff/selectedEnterOrder', data)
    if (res.code === 0) {
      for (const key in formData.value) {
        formData.value[key] = ''
      }
      rkInfoDialog.value = false
      em('refreshDataList', e)
    }

  }
  defineExpose({
    initData,
    cancel,
    handle
  })
</script>

<style scoped lang="scss">
  .consumables-search {
    margin-top: 16px;
  }

  .display_flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .main {
    margin-top: 10px;
  }
</style>